import React from 'react'
import { useMarkToolbarButton, useMarkToolbarButtonState } from '@udecode/plate-common/react'
import { BoxProps, IconButton } from '@ui'
import { IconName } from 'ui/components/Icon'

type Props = {
    nodeType: string
    icon: IconName
    tooltip: React.ReactNode
    clear?: string | string[]
    onClick?: () => void
    background?: BoxProps['background']
}
export const MarkToolbarButton = ({
    clear,
    nodeType,
    icon,
    tooltip,
    onClick,
    background,
}: Props) => {
    const state = useMarkToolbarButtonState({ clear, nodeType })
    const { props } = useMarkToolbarButton(state)

    return (
        <IconButton
            opaque
            active={props.pressed}
            icon={icon}
            background={props.pressed ? 'level3' : background}
            tooltip={tooltip}
            tooltipOptions={{ placement: 'vertical', immediate: true }}
            onClick={onClick ?? props.onClick}
        />
    )
}
